import { AuditLogSchema } from "@redotech/account-common/audit-log";
import * as z from "zod";

/** The client caps these too; this is the bound the server actually enforces. */
const MAX_FILTER_LENGTH = 500;

export const getAuditLog = {
  name: "getAuditLog" as const,
  input: z.object({ _id: z.string() }),
  output: AuditLogSchema.nullable(),
};

export const getAuditLogs = {
  name: "getAuditLogs" as const,
  input: z.object({
    type: z.string().max(MAX_FILTER_LENGTH).optional(),
    createdAt: z.tuple([z.date().nullable(), z.date().nullable()]).optional(),
    team: z.string().max(MAX_FILTER_LENGTH).optional(),
    user: z.string().max(MAX_FILTER_LENGTH).optional(),
    Resource: z.string().max(MAX_FILTER_LENGTH).optional(),
    path: z.string().max(MAX_FILTER_LENGTH).optional(),
    offset: z.number().optional(),
  }),
  output: z.object({
    auditLogs: z.array(AuditLogSchema),
    nextOffset: z.number().nullable(),
  }),
};
